import { Component, Input } from '@angular/core';

import { AirportComment, CommentType } from '../models/airport-comment.model';
import { Contact, ContactType } from '../models/contact.model';


@Component({
  selector: 'app-contact-listing',
  templateUrl: './contact-listing.component.html',
  styleUrls: ['./contact-listing.component.scss']
})
export class ContactListingComponent {
  ContactType = ContactType;

  @Input() contacts: Array<Contact>;

  @Input() remarks: Array<AirportComment>;

  get ownerMgrRemarks(): Array<AirportComment> {
    return (this.remarks || []).filter(remark => remark.commentType === CommentType.OwnerMgr);
  }
}
